/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ECustomSearchType } from './ECustomSearchType';
import {
    ECustomSearchTypeFromJSON,
    ECustomSearchTypeFromJSONTyped,
    ECustomSearchTypeToJSON,
} from './ECustomSearchType';

/**
 * 
 * @export
 * @interface ECustomSearchTypeStringCombinableCriteria
 */
export interface ECustomSearchTypeStringCombinableCriteria {
    /**
     * 
     * @type {ECustomSearchType}
     * @memberof ECustomSearchTypeStringCombinableCriteria
     */
    searchMode?: ECustomSearchType;
    /**
     * 
     * @type {string}
     * @memberof ECustomSearchTypeStringCombinableCriteria
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ECustomSearchTypeStringCombinableCriteria
     */
    secondaryValue?: string | null;
}

/**
 * Check if a given object implements the ECustomSearchTypeStringCombinableCriteria interface.
 */
export function instanceOfECustomSearchTypeStringCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ECustomSearchTypeStringCombinableCriteriaFromJSON(json: any): ECustomSearchTypeStringCombinableCriteria {
    return ECustomSearchTypeStringCombinableCriteriaFromJSONTyped(json, false);
}

export function ECustomSearchTypeStringCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ECustomSearchTypeStringCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : ECustomSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function ECustomSearchTypeStringCombinableCriteriaToJSON(value?: ECustomSearchTypeStringCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': ECustomSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

